import React from "react";
import "./Footer.css";
import facebookLogo from "../Logos/facebook.png";
import youtubeLogo from "../Logos/youtube.png";

const Footer = () => {
  return (
    <footer className="footerShell" role="contentinfo">
      <div className="footerAura" aria-hidden="true" />
      <div className="footerGrid" aria-hidden="true" />

      <div className="footerInner">
        <div className="footerCard footerBrand">
          <p className="footerCopy">© 2025 Rotary Club. Vse pravice pridržane.</p>
          <a
            className="footerLink"
            href="https://rotaryslovenija.org/"
            target="_blank"
            rel="noopener noreferrer"
          >
            O Rotary Slovenija
          </a>
        </div>

        <nav className="footerCard footerSocial" aria-label="Social links">
          <p className="footerSocialTitle">Spremljajte nas</p>

          <ul className="footerSocialList">
            <li>
              <a
                className="footerSocialLink"
                href="https://www.facebook.com/p/Rotary-Club-%C5%BDalec-100076549557937/?locale=sl_SI"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={facebookLogo} alt="" className="footerIcon" />
                <span>Facebook</span>
              </a>
            </li>

            <li>
              <a
                className="footerSocialLink"
                href="https://www.youtube.com/@RotaryClub%C5%BDalec"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={youtubeLogo} alt="" className="footerIcon" />
                <span>YouTube</span>
              </a>
            </li>
          </ul>
        </nav>
      </div>
    </footer>
  );
};

export default Footer;